import Contact from './Contact.js';
import Features from './Features.js';
import About from './About.js';
import MainSec from './MainSec.js';

import React from 'react'

function Body() {
  return (
    <>
    <MainSec/>
    <Features/>
    <About/>
    <Contact/>
    </>
  )
}

export default Body
